import { z } from "zod";
import crypto from "@/lib/cryptography";

export const RequirementSchema = z.object({
  id: z.string().uuid(),
  type: z.enum(["ability", "restriction"]),
  name: z.string(),
  description: z.string().optional(),
});

export const RequirementsSchema = z.array(RequirementSchema).default([
  {
    id: crypto.randomUUID(),
    type: "restriction",
    name: "near-children",
    description: "Must be legally permitted to be within 500 feet of minors.",
  },
  {
    id: crypto.randomUUID(),
    type: "ability",
    name: "forklift license",
    description: "Must hold a valid and current forklift certification.",
  },
  {
    id: crypto.randomUUID(),
    type: "restriction",
    name: "criminal history",
    description: "No felony convictions in the last 7 years.",
  },
  {
    id: crypto.randomUUID(),
    type: "restriction",
    name: "dui",
    description: "No DUI convictions within the past 5 years.",
  },
  {
    id: crypto.randomUUID(),
    type: "ability",
    name: "cdl license",
    description: "Must possess a valid Commercial Driver’s License (CDL).",
  },
  {
    id: crypto.randomUUID(),
    type: "restriction",
    name: "driving record",
    description: "No more than 2 moving violations in the last 3 years.",
  },
  {
    id: crypto.randomUUID(),
    type: "ability",
    name: "hazmat endorsement",
    description: "Must have a valid hazardous materials (HAZMAT) endorsement.",
  },
]);
// export const RequirementsSchema = z
//   .object({
//     $schema: z.string().optional(),
//   })
//   .catchall(RequirementSchema)
//   .default({
//     "near-children": {
//       type: "restriction",
//       description: "must be able to legally be around children.",
//     },
//     "fork-lift": {
//       type: "ability",
//       description: "Class F fork-lift operator, and current.",
//     },
//   });
